import styled, { css } from 'styled-components';

type StepProps = {
  $active?: boolean;
};

export const Container = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km6};
    padding: 0 ${spacing.km2};
    width: 33.5rem;
    max-width: 100%;
    min-height: 30rem;
    position: relative;
  `}
`;

export const CloseContainer = styled.div`
  display: grid;
  justify-content: end;
`;

export const TitleContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km4};
    padding-bottom: ${spacing.km2};
  `}
`;

export const ChildrenContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km8};
    padding-bottom: ${spacing.km8};
  `}
`;

export const Footer = styled.div`
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-rows: max-content;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
`;

export const InvisibleSpace = styled.div`
  width: 6.75rem;
`;

export const Steps = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-auto-flow: column;
    grid-auto-rows: 0.5rem;
    grid-auto-columns: 2.5rem;
    grid-gap: ${spacing.km2};
  `}
`;

export const Step = styled.div<StepProps>`
  ${({ theme: { color, border }, $active }) => css`
    background-color: ${$active ? color.background.brand.default : color.background.neutral.weak};
    border-radius: ${border.radius.default};
    cursor: pointer;
  `}
`;
